import { queryClient } from "~/plugins/vue-query";
import { schedulesService } from "~/utils/api/schedulesService";
import { getProjectId } from "~/utils/getProjectId";

export default defineNuxtRouteMiddleware(async () => {
  const projectId = getProjectId();

  if (projectId) {
    queryClient.fetchQuery({
      queryKey: ["schedule"],
      queryFn: () =>
        schedulesService.getSchedules({
          client_project_id: projectId,
        }),
    });
  }
});
